const CHECKOUT_SELECTOR = 'button[name="checkout"][form="cart-form"], button#checkout[name="checkout"]';
const LISTENER_KEY = '__beyloraCartCheckoutIntegrity';
window.__beyloraCartCheckoutIntegrityVersion = '20260510-ring-size-cache-probe';

function getCartRoot() {
  return window.Shopify?.routes?.root || '/';
}

function visibleProperties(item) {
  return Object.fromEntries(
    Object.entries(item.properties || {}).filter(([key, value]) => key && !key.startsWith('_') && value != null && value !== '')
  );
}

function base64EncodeJson(value) {
  const bytes = new TextEncoder().encode(JSON.stringify(value));
  let binary = '';
  bytes.forEach((byte) => {
    binary += String.fromCharCode(byte);
  });

  return btoa(binary);
}

function buildCheckoutUrl(cart) {
  const cartRoot = getCartRoot();
  const itemsWithProperties = cart.items.filter((item) => Object.keys(visibleProperties(item)).length > 0);

  if (itemsWithProperties.length > 1 || (itemsWithProperties.length === 1 && cart.items.length > 1)) {
    return `${cartRoot}checkout?_beylora_checkout=${Date.now()}`;
  }

  const lineItems = cart.items
    .map((item) => `${encodeURIComponent(item.variant_id)}:${encodeURIComponent(item.quantity)}`)
    .join(',');
  const params = [];

  if (itemsWithProperties.length === 1) {
    params.push(`properties=${encodeURIComponent(base64EncodeJson(visibleProperties(itemsWithProperties[0])))}`);
  }

  params.push('checkout');
  params.push(`_beylora_checkout=${Date.now()}`);

  return `${cartRoot}cart/${lineItems}?${params.join('&')}`;
}

function submitNormally(button) {
  button.dataset.beyloraCheckoutBypass = 'true';
  button.disabled = false;
  button.removeAttribute('aria-busy');
  button.click();
}

async function redirectToExactCheckout(button) {
  button.disabled = true;
  button.setAttribute('aria-busy', 'true');

  const response = await fetch(`${getCartRoot()}cart.js`, {
    headers: { Accept: 'application/json' },
    cache: 'no-store',
  });

  if (!response.ok) throw new Error(`Cart JSON request failed: ${response.status}`);

  const cart = await response.json();
  if (!cart.items?.length) {
    window.location.assign(`${getCartRoot()}cart`);
    return;
  }

  window.location.assign(buildCheckoutUrl(cart));
}

if (!window[LISTENER_KEY]) {
  window[LISTENER_KEY] = true;

  document.addEventListener(
    'click',
    (event) => {
      const button = event.target.closest(CHECKOUT_SELECTOR);
      if (!button || button.dataset.beyloraCheckoutBypass === 'true') return;

      event.preventDefault();
      event.stopPropagation();

      redirectToExactCheckout(button).catch((error) => {
        console.error('Beylora checkout integrity redirect failed.', error);
        submitNormally(button);
      });
    },
    true
  );
}
